import { LIVE_STATUS } from '@/types/global';

const meta = new URL((document.currentScript as HTMLScriptElement).src);

export const SDK_TOKEN: string = meta.searchParams.get('sdk_token') ?? '';
export const TEMPLATE_ID: string = meta.searchParams.get('template_id') ?? '';
export const IS_GENERAL_CMS: boolean = meta.searchParams.has('general');

export const BUGSNAG_API_KEY: string = import.meta.env.VITE_APP_BUGSNAG_API_KEY ?? '';
export const STREAM_BASE_URI: string = import.meta.env.VITE_APP_STREAM_BASE_URI ?? '';
export const TRACKER_BASE_URI: string = import.meta.env.VITE_APP_TRACKER_BASE_URI ?? '';

export const IS_DEBUG_MODE: boolean = import.meta.env.VITE_APP_STAGE === 'development';
export const IS_DEV_STAGE: boolean = import.meta.env.VITE_APP_STAGE === 'development';
export const IS_PROD_STAGE: boolean = import.meta.env.VITE_APP_STAGE === 'production';

export { LIVE_STATUS };
